import React from 'react'
import { isValid, parseJSON } from 'date-fns'
import { CallOnShow } from '../types'
import { FormattedMessage } from 'react-intl'
import { formatDate, parseJsonDate } from '~/utils/dateFns'
import { isObject } from 'lodash'

type Props = {
  call: CallOnShow
}

const TelemarketingCustomData: React.FC<Props> = ({ call }) => {
  const data = call.tmContact!.customData!

  return (
    <>
      <h2>
        <span className="far fa-bullhorn" />
        <FormattedMessage id="call / telemarketing / custom data" />
      </h2>

      <table className="call-show-tmCustomData table is-bordered is-striped is-narrow">
        <tbody>
          {Object.keys(data).map(key => (
            <tr key={key}>
              <th>{key}</th>
              <td>
                <Cell val={data[key]} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default TelemarketingCustomData

type CellProps = {
  val: any
}

const Cell: React.FC<CellProps> = ({ val }) => {
  const date = parseJsonDate(val)

  return Array.isArray(val) && isObject(val[0]) ? (
    <>
      {val.map((row, k) => (
        <table key={k} className="table is-bordered is-striped is-narrow">
          <tbody>
            {Object.keys(row).map(k2 => (
              <tr key={k2}>
                <th>{k2}</th>
                <td>
                  <Cell val={row[k2]} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ))}
    </>
  ) : Array.isArray(val) ? (
    <>
      <table className="table is-bordered is-striped is-narrow">
        <tbody>
          {val.map((v2, k) => (
            <tr key={k}>
              <td>
                <Cell val={v2} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  ) : date ? (
    <>{formatDate(date, 'PPPPp')}</>
  ) : (
    <>{val}</>
  )
}
